export default "__VITE_ASSET__Bju2ha10__"